import React, { useState } from 'react';
import axios from 'axios';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { CheckCircle, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ChatLeadForm = ({ sessionId, onClose }) => {
  const [form, setForm] = useState({ nombre: '', email: '', telefono: '' });
  const [state, setState] = useState('idle');
  const [message, setMessage] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setState('loading');
    try {
      const { data } = await axios.post(`${API}/chat/lead`, { session_id: sessionId, ...form, telefono: form.telefono || null });
      setMessage(data.message);
      setState('done');
    } catch (err) {
      setMessage(err.response?.data?.detail?.[0]?.msg || err.response?.data?.detail || 'No pudimos guardar tus datos. Intenta de nuevo.');
      setState('error');
    }
  };

  if (state === 'done') {
    return (
      <div className="rounded-2xl bg-emerald-50 border border-emerald-100 p-4 text-sm text-emerald-800 flex gap-2" data-testid="chat-lead-success">
        <CheckCircle className="h-5 w-5 shrink-0" /> <span>{message}</span>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="rounded-2xl bg-blue-50 border border-blue-100 p-4 space-y-2.5" data-testid="chat-lead-form">
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-semibold text-slate-800">Déjanos tus datos y un asesor te contacta</p>
        <button type="button" onClick={onClose} aria-label="Cerrar formulario" data-testid="chat-lead-close" className="text-slate-400 hover:text-slate-600"><X className="h-4 w-4" /></button>
      </div>
      <Input data-testid="chat-lead-nombre" required minLength={2} value={form.nombre} onChange={(e) => setForm({ ...form, nombre: e.target.value })} placeholder="Tu nombre" className="h-10 bg-white rounded-xl" />
      <Input data-testid="chat-lead-email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Tu email" className="h-10 bg-white rounded-xl" />
      <Input data-testid="chat-lead-telefono" value={form.telefono} onChange={(e) => setForm({ ...form, telefono: e.target.value })} placeholder="Teléfono / WhatsApp (opcional)" className="h-10 bg-white rounded-xl" />
      {state === 'error' && <p className="text-xs text-red-600" data-testid="chat-lead-error">{typeof message === 'string' ? message : 'Datos inválidos.'}</p>}
      <Button type="submit" disabled={state === 'loading'} data-testid="chat-lead-submit" className="w-full h-10 rounded-xl bg-red-500 hover:bg-red-400 font-semibold">
        {state === 'loading' ? 'Enviando...' : 'Quiero que me contacten'}
      </Button>
    </form>
  );
};

export default ChatLeadForm;
